module.exports = __webpack_public_path__ + "static/media/German.576119f5.svg";